import { ApiService } from '../../services/api_service';
import { BenchmarkSVG } from './helper/elements/BenchmarkSVG';
import { ContextService } from '../../services/context_service';
import { DatenauswertungCO2FussabdruckDetails } from './DatenauswertungCO2FussabdruckDetails';
// import { formatNumber } from '../../core/formatter/formatNumber';
import formStyle from '../../core/forms/style/WForm.less';
import { getBetrieblicheSituationName, getGewerk, getGewerkName } from '../../main/functions/getGewerk';
import { getStaticOption } from '../../core/forms/helpers/getStaticOption';
import { getStyle } from './generisch/DatanauswertungGenerischStyles';
import { IDs } from '../../helpers/IDs';
import { i18n } from '../../i18n/i18n';
import { Image, Text, View } from '@react-pdf/renderer';
import { KennzahlenAuswahl } from './elements/KennzahlenAuswahl';
import { lazyInject } from '../../services/inversify';
import { parsePdfSub2 } from './generisch/helper';
import * as React from 'react';
import { SectionStyle } from '../../helpers/SectionStyle';
import { svgToPng } from '../helper';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WpdfText } from './pdf/WpdfText.';
import { WpdfView } from './pdf/WpdfView';

interface EnergieCockpitBenchmarkingProps extends React.ClassAttributes<any> {
    data: any;
    jahr: number;
    onKennzahlChange?: (kennzahl: string) => void;
    onKennzahlChange2?: (kennzahl: string) => void;
    onPdfDataLoaded?: (data: JSX.Element) => void;
    standort: number;
}

interface EnergieCockpitBenchmarkingState {
    isLoading: boolean;
    isReady: boolean;
    isSmall: boolean;
    wrapper: any;
    // Werte 1
    start1: number;
    end1: number;
    value1: number;
    average1: number;
    einheit1: string;
    message1_1: string;
    message1_2: string;
    showBar1: boolean;
    anzahl1: number;
    // Werte 2
    start2: number;
    end2: number;
    value2: number;
    average2: number;
    einheit2: string;
    message2_1: string;
    message2_2: string;
    showBar2: boolean;
    anzahl2: number;
    // Auswahl:
    kennzahlSelected1: string;
    kennzahlSelected2: string;
    showAll: boolean;
    showCluster: boolean;
    chartSelector: JSX.Element;
}

export class EnergieCockpitBenchmarking extends React.Component<EnergieCockpitBenchmarkingProps, EnergieCockpitBenchmarkingState> {

    constructor(props: any) {
        super(props);

        // Kennzahlen holen, um zu prüfen, ob wir energiekosten_ma nehmen können
        const standort = this.props.standort;
        const kennzahlen_eigene = standort
            ? (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort] || {}
            : this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};

        const energiekosten_ma = (kennzahlen_eigene[this.props.jahr] || {}).energiekosten_ma || 0;


        // Hinweis: Jahr = 0 = ALLE JAHRE (wird bei der Aggregation mit erzeugt, aber nur dort!)
        const kennzahlSelected1 = this.contextService.get('benchmarkingKennzahl1') || energiekosten_ma > 0 ? 'energiekosten_ma' : 'co2_emission';
        const kennzahlSelected2 = this.contextService.get('benchmarkingKennzahl2') || 'energiekosten_umsatz';

        this.state = {
            isLoading: false,
            isReady: false,
            isSmall: null,
            wrapper: null,
            start1: 100,
            end1: 1000,
            value1: 500,
            average1: 600,
            einheit1: '',
            kennzahlSelected1,
            kennzahlSelected2,
            showBar1: false,
            showBar2: false,
            message1_1: '',
            message1_2: '',
            anzahl1: 0,
            start2: 200,
            end2: 2000,
            value2: 500,
            average2: 600,
            einheit2: '',
            message2_1: '',
            message2_2: '',
            anzahl2: 0,
            showAll: this.contextService.get('benchmarkShowAll'),
            showCluster: this.contextService.get('benchmarkShowCluster'),
            chartSelector: null
        };
        this.wrapper = React.createRef();
        this.onResize = this.onResize.bind(this);
        this.processPdfData = this.processPdfData.bind(this);
        this.selectKennzahl = this.selectKennzahl.bind(this);
        this.setAgain = this.setAgain.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private backgroundColorSectionTable: string;
    private colorDatenauswertung: string;
    private currentJahr: number;
    private wrapper: any;
    private co2Fussabdruck: boolean;
    private co2Diagram: any;
    private clusterSwitchTime = 0;

    componentDidMount(): void {
        window.addEventListener('resize', this.onResize);
        this.currentJahr = this.props.jahr;
        this.setAgain(false);
        this.triggerService.register('kz_aggregation_reload', '', this.setAgain);

        if (typeof this.props.onKennzahlChange === 'function') {
            this.props.onKennzahlChange(this.state.kennzahlSelected1);
        }

        if (typeof this.props.onKennzahlChange2 === 'function') {
            this.props.onKennzahlChange2(this.state.kennzahlSelected2);
        }
        this.setColors();
        this.checkFlagHasCo2();
    }

    componentDidUpdate(prevProps: any, prevState: any): void | JSX.Element {
        if (this.props.jahr !== this.currentJahr || this.props.standort !== prevProps.standort) {
            this.currentJahr = this.props.jahr;
            this.selectKennzahl(1, this.state.kennzahlSelected1, this.props.jahr, this.props.standort);
            this.selectKennzahl(2, this.state.kennzahlSelected2, this.props.jahr, this.props.standort);
            this.setState({ isReady: false }, this.processPdfData);
        }

        if (this.state.kennzahlSelected1 !== prevState.kennzahlSelected1) {
            this.setState({ isReady: false }, this.processPdfData);
            if (typeof this.props.onKennzahlChange === 'function') {
                this.props.onKennzahlChange(this.state.kennzahlSelected1);
            }
        } else if (this.state.kennzahlSelected2 !== prevState.kennzahlSelected2) {
            this.setState({ isReady: false }, this.processPdfData);
            if (typeof this.props.onKennzahlChange2 === 'function') {
                this.props.onKennzahlChange2(this.state.kennzahlSelected2);
            }
        } else if ((!this.state.isReady && typeof this.props.onPdfDataLoaded === 'function')
            || (this.wrapper.current && this.wrapper.current.children.length === this.wrapper.current.querySelectorAll('#Entwicklungsplan_SVG').length)) {
            this.processPdfData();
        }

        if (this.wrapper.current !== null && this.state.isSmall === null) {
            this.onResize();
        }

        this.checkFlagHasCo2();
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.onResize);
        this.triggerService.unregister('kz_aggregation_reload', '', this.setAgain);
    }

    checkFlagHasCo2() {
        const kennzahlen: any = this.props.standort
            ? (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT][this.props.standort] || {}) || {}
            : this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
        const flags: any = kennzahlen.flags || {};
        // this.co2Fussabdruck = false;
        this.co2Fussabdruck = flags.hasCO2;
        // console.log(this.co2Fussabdruck);
    }

    getPdfData(images: any[]): void {
        const konfiguration: any[] = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const disabledCO2Komplex: boolean = !IDs.FLAG_ENABLE_SCOPE3
            || !konfiguration.some((param: any) => param.co2_fussabdruck_orig === 1);
        const { jahr } = this.props;
        const co2Diagram = this.co2Diagram;
        const data: any = (images || [])[0] || {};
        const data2: any = (images || [])[1] || {};
        const gewerk: string = (getGewerkName(this.props.data) || '').trim();
        const gewerk_tid = getGewerk(this.props.data);
        const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        const kennzahlen: any[] = this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION] || [];
        const kennzahl: string = (kennzahlen.find((item: any) => item.kuerzel === this.state.kennzahlSelected1) || {}).name || null;
        const kennzahl2: string = (kennzahlen.find((item: any) => item.kuerzel === this.state.kennzahlSelected2) || {}).name || null;
        const styleLegendTitel = getStyle('legendTitel');
        styleLegendTitel.fontSize = '8pt';

        const show_vergleich: boolean = (gewerk_tid !== 147) && bereich_key === 'handwerk'
            && ((this.co2Fussabdruck && images.length > 1) || !this.co2Fussabdruck);
        // console.log('Gewerk Cockpit :', show_vergleich, gewerk_tid, gewerk, bereich_key);
        this.props.onPdfDataLoaded(
            <>
                <View
                    style={{
                        margin: 0, border: '1 solid #e9e9e9', flexDirection: 'row',
                        ...(!show_vergleich ? { maxWidth: '50%', minWidth: '50%' } : {})
                    }}
                >
                    {show_vergleich &&
                        <View style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                            <View
                                style={{
                                    backgroundColor: '#e7e7e7', marginBottom: 10, padding: 2, display: 'flex', flex: 1, flexDirection: 'row',
                                    justifyContent: 'space-between', alignItems: 'center'
                                }}
                            >
                                <View style={{ color: 'black' }}>
                                    <Text style={{ fontFamily: 'Helvetica-Bold', fontSize: '10pt' }}>
                                        {i18n('Betriebsvergleich', 'sys')}
                                    </Text>
                                </View>
                                <View style={{ fontSize: '9pt', color: '#555' }}>
                                    <Text>
                                        {/* <Text style={{ fontFamily: 'Helvetica-Bold' }}>KENNZAHL: </Text> */}
                                        {parsePdfSub2(kennzahl, { fontSize: '9pt' })}
                                    </Text>
                                </View>
                            </View>
                            <View
                                key='image'
                                style={{
                                    margin: 'auto', marginTop: 0, padding: '5px 5px 0 5px', height: 180, display: 'flex',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                {data.image || null}
                                {this.renderLegende(true)}
                                <React.Fragment key='message'>{this.renderMessages(1, true)}</React.Fragment>
                            </View>
                        </View>
                    }
                    <View
                        style={{
                            display: 'flex', flex: 1, flexDirection: 'column', ...(show_vergleich ? { borderLeft: '1 solid #e9e9e9' } : {})
                        }}
                    >
                        <View
                            style={{
                                backgroundColor: '#e9e9e9', marginBottom: 10, padding: 2, display: 'flex', flex: 1, flexDirection: 'row',
                                justifyContent: 'space-between', alignItems: 'center'
                            }}
                        >
                            {this.co2Fussabdruck &&
                                <View style={{ color: 'black' }}>
                                    <Text style={{ fontFamily: 'Helvetica-Bold', fontSize: '10pt' }}>
                                        {parsePdfSub2(
                                            `${i18n('Auswertung CO₂-Fußabdruck', 'sys')} / ${i18n('Jahr', 'sys')} ${jahr} / Scopes 1-${disabledCO2Komplex ? '2' : '3'}`,
                                            { fontSize: '9pt' }
                                        )}
                                    </Text>
                                </View>
                            }
                            <View
                                style={{
                                    fontSize: '9pt', color: '#555', display: 'flex', flex: 1, flexDirection: 'row',
                                    justifyContent: 'flex-end'
                                }}
                            >
                                {!this.co2Fussabdruck &&
                                    <Text>
                                        {/* <Text style={{ fontFamily: 'Helvetica-Bold' }}>{i18n('KENNZAHL', 'sys')}: </Text> */}
                                        {parsePdfSub2(kennzahl2, { fontSize: '9pt' })}
                                    </Text>
                                }
                            </View>
                        </View>
                        <View
                            key='image2'
                            style={{
                                margin: 'auto', marginTop: 0, padding: '5px 5px 0 5px', height: 180, display: 'flex',
                                justifyContent: 'flex-end',
                                ...this.co2Fussabdruck ? { alignItems: 'center', justifyContent: 'flex-start' } : {}
                            }}
                        >
                            {this.co2Fussabdruck ?
                                <View style={{ display: 'flex', flexDirection: 'row', padding: 5 }}>
                                    <View
                                        style={{
                                            width: '60%', marginTop: -34/*show_vergleich ? -30 : -100*/,
                                            // height: ((show_vergleich ? data2 : data).height || 0) * 0.6
                                        }}
                                    >
                                        {(show_vergleich ? data2.image : data.image) || null}
                                    </View>
                                    <View style={{ ...getStyle('legendWrapper'), width: '40%', justifyContent: 'flex-start' }}>
                                        {co2Diagram && Array.isArray(co2Diagram.legend) && co2Diagram.legend.map((name: any, i: number) => {
                                            const color = co2Diagram && co2Diagram.legendIconColor && co2Diagram.legendIconColor[i]
                                                ? co2Diagram.legendIconColor[i] : 'white';
                                            return (
                                                <View
                                                    key={`legend-${i}`}
                                                    style={{
                                                        display: 'flex', flexDirection: 'row', alignItems: 'center',
                                                        backgroundColor: 'white'
                                                    }}
                                                >
                                                    <Text style={{ ...getStyle('legendIcon'), backgroundColor: color }}></Text>
                                                    <Text style={styleLegendTitel}>{parsePdfSub2(name, styleLegendTitel)}</Text>
                                                </View>
                                            );
                                        })}
                                    </View>
                                </View> :
                                <View>
                                    {data2.image || null}
                                    {this.renderLegende(true)}
                                    <React.Fragment key='message2'>{this.renderMessages(2, true)}</React.Fragment>
                                </View>
                            }
                        </View>
                    </View>
                </View>
                {show_vergleich &&
                    <View
                        style={{
                            paddingBottom: 5, border: '1 solid #e9e9e9', borderTopWidth: 0, flexDirection: 'row',
                            // ...(!this.co2Fussabdruck ? { justifyContent: 'center' } : {})
                        }}
                    >
                        {this.renderInfo(true)}
                    </View>
                }
            </>
        );
    }

    getStyle(isPdf?: boolean): any {
        return ({
            tabelle: {
                fontSize: '7pt',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            tabelle1: {
                maxWidth: isPdf ? 377 : 504,
                marginLeft: isPdf ? 38 /* 44 */ : -50 /* 92 */,
                ...(!isPdf && { paddingBottom: 22 /* 30 */ })
            },
            tabelle2: {
                maxWidth: isPdf ? 421 : 596
            },
            col1: {
                padding: isPdf ? '0 5px' : '0 5px 0 20px',
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                flexBasis: isPdf ? 44 : 92,
                alignItems: isPdf ? 'flex-end' : 'flex-start',
                boxSizing: 'border-box'
            },
            col2: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                flexBasis: isPdf ? 700 /* 377 */ : 504
            },
            message: {
                fontSize: '9pt',
                paddingTop: 4,
                display: 'flex',
                flexDirection: 'column',
                ...(!isPdf && { marginTop: 15 })
            }
        });
    }

    onResize(): void {
        if (this.wrapper.current) {
            const rect: any = this.wrapper.current.getBoundingClientRect();
            this.setState({
                isSmall: rect.width < (this.co2Fussabdruck ? 1299 : 1300) || rect.right < (this.co2Fussabdruck ? 1314 : 1315)
            });
        }
    }

    async processPdfData(forceProcess = false): Promise<void> {
        const entwicklungsplaene: NodeListOf<HTMLElement> = document.querySelectorAll('#Entwicklungsplan_SVG');
        const data: any[] = await [];
        const images: any[] = await [];
        let skipped: number = 0;

        if (entwicklungsplaene.length) {
            entwicklungsplaene.forEach((entwicklungsplan: any) => {
                images.push(entwicklungsplan);
            });
        }

        if (this.co2Fussabdruck) {
            const graph = document.getElementsByClassName('recharts-responsive-container');

            if (graph && graph[2]) {
                const elem = graph[2].children[0].children[0];
                images.push(elem);
            }
        }
        const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        const gewerk_tid = getGewerk(this.props.data);
        const show_vergleich: boolean = (gewerk_tid !== 147) && bereich_key === 'handwerk'
            && ((this.co2Fussabdruck && images.length > 1) || !this.co2Fussabdruck);

        const finish = () => {
            if ((data.length + skipped) === images.length && (!this.state.isReady || forceProcess)) {
                // console.log('processPdfData finished', data);
                this.setState({ isReady: true }, () => this.getPdfData(data));
            }
        };

        images.forEach(async (item: any, index: number) => {
            const html: HTMLElement = item || <svg />;
            const rect = html.getBoundingClientRect();
            if (rect.width > 1 && rect.height > 1) {
                const svg = new XMLSerializer().serializeToString(html);
                const svgBlob = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
                let image: any, imgStyle: any;
                if (((show_vergleich && index) || (!show_vergleich && !index)) && this.co2Fussabdruck) {
                    // PieChart
                    const rad = rect.width;
                    image = await svgToPng(svgBlob, rad, rad, 3);
                    imgStyle = { width: rad * 0.6, height: rad * 0.6 };
                } else {
                    image = await svgToPng(svgBlob, rect.width, rect.height, 3);
                    imgStyle = { maxWidth: rect.width * 0.75 };
                }
                data.push({
                    image: <Image src={image} style={imgStyle} />,
                    width: rect.width,
                    height: rect.height
                });
            } else {
                ++skipped;
            }

            if (index === images.length - 1) {
                finish();
            }
        });

        if (entwicklungsplaene.length && !images.length) {
            this.setState({ isReady: true }, () => this.getPdfData(data));
        }
    }

    render(): JSX.Element {
        const { data } = this.props;
        const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        const gewerk_tid = getGewerk(this.props.data);
        const info_gewerk = this.props.data['info_gewerk'];
        const hideVergleich = gewerk_tid === 147 || bereich_key !== 'handwerk' || !info_gewerk
            || (info_gewerk.gewerk_use_cluster && !info_gewerk.betriebliche_situation);
        const kennzahlen_aggregiert = (data[IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION] || []).filter((item: any) => (item.modus || 100) === 100);
        // console.log('Info Gewerk', info_gewerk);

        if (!this.co2Fussabdruck && (getGewerkName(this.props.data) || '').trim() === 'Kein Handwerk') {
            return null;
        }
        console.log('Kennzahlen Aggregiert: ', kennzahlen_aggregiert, this.state.showCluster, this.state.kennzahlSelected1, this.state.anzahl1);
//        if ((!kennzahlen_aggregiert || kennzahlen_aggregiert.length < 10) && !this.state.showCluster) {
        // UMSCHALTUNG CLUSTER ----> FEHLERHAFT *******************
        if ( false && (!this.state.anzahl1 || this.state.anzahl1 < 10) && !this.state.showCluster) {
            if (this.clusterSwitchTime < new Date().getTime() - 5000) {
                // console.log('Benchmarking: Zu wenig Daten --> Wechsel zum Cluster (Betriebssituation)');
                this.clusterSwitchTime = new Date().getTime(); // Damit wir bei mehreren Renders nicht zu oft laden.
                window.setTimeout(() => {
                    this.setState({ showCluster: true },
                        () => {
                            this.contextService.set('benchmarkShowCluster', this.state.showCluster);
                            this.triggerService.fire('reload', IDs.ENT_UNTERNEHMENSDATEN);
                        }
                    );
                }, 100);
            }
            return <div>{i18n('Lade', 'sys')}...</div>;
        }

        return this.co2Fussabdruck ?
            <div style={{ display: 'flex', flexDirection: 'row'/*, flexWrap: 'wrap'*/ }} ref={this.wrapper}>
                {this.renderBetriebsvergleich(1)}
                <div
                    style={{
                        backgroundColor: this.backgroundColorSectionTable || 'transparent', marginBottom: 20, paddingBottom: 10,
                        borderTopRightRadius: 'var(--border-radius-headline)', borderTopLeftRadius: 'var(--border-radius-headline)',
                        boxShadow: 'var(--assistent-box-shadow)', display: 'flex', flexDirection: 'column'
                    }}
                >
                    {this.renderCo2FussabdruckTitelWrapper()}
                    {this.renderCo2Fussabdruck()}
                </div>
            </div> :
            <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                {!hideVergleich && <>
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'row'/*, flexWrap: 'wrap'*/ }}>
                        {this.renderTitelWrapper(1)}
                        {this.renderTitelWrapper(2)}
                    </div>
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'row'/*, flexWrap: 'wrap'*/ }} ref={this.wrapper}>
                        {this.renderContentWrapper(1)}
                        {this.renderContentWrapper(2)}
                    </div>
                    <div style={{ paddingBottom: 10, display: 'flex', flex: 1, flexDirection: 'row'/*, flexWrap: 'wrap'*/ }}>
                        {this.renderLegendeWrapper(1)}
                        {this.renderLegendeWrapper(2)}
                    </div>
                </>}
            </div>;
    }

    renderBetriebsvergleich(idx: number): JSX.Element {
        const bereich_key: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        const gewerk_tid = getGewerk(this.props.data);
        const info_gewerk = this.props.data['info_gewerk'];
        // console.log('Info Gewerk', info_gewerk);
        if (gewerk_tid === 147 || bereich_key !== 'handwerk' || !info_gewerk || (info_gewerk.gewerk_use_cluster && !info_gewerk.betriebliche_situation)) {
            return null;
        }

        return (
            <div
                style={{
                    backgroundColor: this.backgroundColorSectionTable || 'transparent', marginBottom: 20, borderRadius: '10px 10px 0 0',
                    boxShadow: 'var(--assistent-box-shadow)', display: 'flex', flexDirection: 'column',
                    ...(+idx === 1 && { marginRight: 20 })
                }}
            >
                {this.renderTitelWrapper(idx)}
                {this.renderContentWrapper(idx)}
                {this.renderLegendeWrapper(idx)}
            </div>
        );
    }

    renderCo2FussabdruckTitelWrapper(): JSX.Element {
        const konfiguration: any[] = this.props.data[IDs.ENT_KONFIGURATION] || [];
        const disabledCO2Komplex: boolean = !IDs.FLAG_ENABLE_SCOPE3
            || !konfiguration.some((param: any) => param.co2_fussabdruck_orig === 1);
        const { jahr } = this.props;
        const { chartSelector } = this.state;

        return (
            <div
                style={{
                    maxWidth: 640/*648*/, minWidth: 640/*648*/, marginRight: 0, borderTopRightRadius: 'var(--border-radius-headline)',
                    borderTopLeftRadius: 'var(--border-radius-headline)', display: 'flex', flexDirection: 'column', zIndex: 0
                }}
            >
                <div
                    style={{
                        fontWeight: 600, fontSize: 'var(--font-size-headline)', backgroundColor: 'var(--color-bg-headline)',
                        maxHeight: 'var(--height-headline)', minHeight: 'var(--height-headline)', padding: '0 10px 0 20px',
                        borderTopRightRadius: 'var(--border-radius-headline)', borderTopLeftRadius: 'var(--border-radius-headline)',
                        display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'
                    }}
                >
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <span style={{ marginRight: 5 }}>
                            {`${i18n('Auswertung CO₂-Fußabdruck', 'sys')} / ${i18n('Jahr', 'sys')} ${jahr} / Scopes 1-${disabledCO2Komplex ? '2' : '3'}`}
                        </span>
                        <WHelpIcon
                            data={this.props.data}
                            styleDivProps={{ display: 'flex', alignSelf: 'center' }}
                            styleProps={{ margin: 0 }}
                            label={i18n('Auswertung CO₂-Fußabdruck', 'sys')}
                            helpKey='energie_cockpit_auswertung_co2_fussabdruck'
                            type='theme_info'
                            style='theme_small'
                            customElement='Info'
                            editBar
                            useTheme
                        />
                    </div>
                    <div
                        ref={(ref: any) => {
                            if (!ref || !ref.children.length) {
                                return;
                            }
                            const select: HTMLElement = ref.querySelector('select');
                            if (select && select.style) {
                                select.style.setProperty('background-color', 'var(--color-wform-field-bg)');
                                select.style.setProperty('max-height', 'var(--formfields-compact-height)');
                                select.style.setProperty('min-height', 'var(--formfields-compact-height)');
                            }
                        }}
                    >
                        <div className={formStyle.formCompact}>{chartSelector}</div>
                    </div>
                </div>
            </div>
        );
    }

    renderCo2Fussabdruck(): JSX.Element {
        const { data, jahr, standort } = this.props;

        return (
            <div style={{ maxWidth: 640/*648*/, minWidth: 640/*648*/, display: 'flex', flex: 1, flexDirection: 'column' }}>
                <DatenauswertungCO2FussabdruckDetails
                    key={`DatenauswertungCO2FussabdruckDetails_Jahr_${jahr}`}
                    parentElement='EnergieCockpit'
                    data={data}
                    onRoutingChange={() => { }}
                    routing={null}
                    standortTid={standort}
                    standortName=''
                    jahr={jahr}
                    chartOnly={true}
                    hideChartTitle={true}
                    diagramStyle={{ border: 0 }}
                    getChartSelector={(element: JSX.Element) => !this.state.chartSelector && this.setState({ chartSelector: element })}
                    onChartSelectChange={(co2Diagram: any) => {
                        if (JSON.stringify(this.co2Diagram) !== JSON.stringify(co2Diagram)) {
                            this.co2Diagram = co2Diagram;
                            this.processPdfData(true);
                        }
                    }}
                />
            </div>
        );
    }

    renderContent(column: number): JSX.Element {
        const isFirstColumn: boolean = +column === 1;
        const svg = (
            <svg
                id='Entwicklungsplan_SVG'
                viewBox={`0 0 ${500 + 40} ${40 + 110}`}
                width={500 + 80}
                height={this.state.showBar1 || this.state.showBar2 ? 40 + 110 : 1}
            />
        );

        return (
            <>
                {isFirstColumn && this.state.showBar1 &&
                    <BenchmarkSVG
                        rangeStart={this.state.start1}
                        rangeEnd={this.state.end1}
                        value={this.state.value1}
                        average={this.state.average1}
                        einheit={this.state.einheit1}
                    />
                }
                {isFirstColumn && !this.state.showBar1 && svg}
                {!isFirstColumn && this.state.showBar2 &&
                    <BenchmarkSVG
                        rangeStart={this.state.start2}
                        rangeEnd={this.state.end2}
                        value={this.state.value2}
                        average={this.state.average2}
                        einheit={this.state.einheit2}
                    />
                }
                {!isFirstColumn && !this.state.showBar2 && svg}
                {this.renderMessages(isFirstColumn ? 1 : 2)}
            </>
        );
    }

    renderContentWrapper(column: number): JSX.Element {
        const isFirstColumn: boolean = +column === 1;
        const marginTop: React.CSSProperties = !this.state.isSmall || (this.state.isSmall && isFirstColumn) ? { marginTop: 15 } : {};
        const borderBottom: React.CSSProperties = {
            borderBottom: `1px solid ${!this.state.isSmall || (this.state.isSmall && (!isFirstColumn || this.co2Fussabdruck))
                ? 'var(--color-bg-headline, #e9e9e9)' : this.backgroundColorSectionTable || 'transparent'}`,
            // borderBottom: `1px solid ${!this.state.isSmall || (this.state.isSmall && !isFirstColumn)
            //    ? 'var(--color-bg-headline, #e9e9e9)' : this.backgroundColorSectionTable || 'transparent'}}`
            ...(isFirstColumn && !this.co2Fussabdruck && { marginRight: 20 })
        };

        return (
            <div
                style={{
                    backgroundColor: this.backgroundColorSectionTable || 'transparent', maxWidth: 640/*648*/, minWidth: 640/*648*/,
                    paddingBottom: 5, ...borderBottom, boxSizing: 'border-box',display: 'flex', flex: 1, flexDirection: 'column',
                    alignItems: 'center'
                }}
            >
                <div
                    style={{
                        display: 'flex', flex: 1, flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', ...marginTop
                    }}
                >
                    {this.renderContent(column)}
                    {(isFirstColumn || !this.state.isSmall) && this.renderLegende()}
                </div>
            </div>
        );
    }

    renderHelpIcon(): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ display: 'flex', alignSelf: 'center' }}
                styleProps={{ margin: 0 }}
                label={i18n('Energie Cockpit - Benchmarking', 'sys')}
                helpKey='energie_cockpit_benchmarking'
                type='theme_info'
                style='theme_small'
                customElement='Info'
                editBar
                useTheme
            />
        );
    }

    renderInfo(isPdf?: boolean): JSX.Element {
        const styles: any = this.getStyle(isPdf);

        return (
            <WpdfView
                style={{ ...styles.tabelle, ...styles.tabelle2, marginTop: 5 }}
                pdf={isPdf}
            >
                <WpdfView style={{ display: 'flex', flexDirection: 'row', marginTop: 2 }} pdf={isPdf}>
                    <WpdfView style={styles.col1} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>{i18n('Info', 'sys')}</WpdfText>
                    </WpdfView>
                    <WpdfView style={styles.col2} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>
                            {i18n('Wenn für das von Ihnen in den Unternehmensdaten ausgewählte Gewerk keine oder zu wenige Datensätze in unserer Datenbank vorhanden sind, um eine sinnvolle Darstellung zu ermöglichen, wird das Gewerk einem der drei folgenden übergeordneten Gruppen (Cluster) zugeordnet', 'sys')}:
                            {i18n('Tätigkeiten überwiegend', 'sys')}...{isPdf ? '\n' : <br />}
                            1) ...{i18n('bei Kunden bzw. a.d. Baustelle', 'sys')} 2) ...{i18n('in einem Ladengeschäft', 'sys')} 3) ...{i18n('in einer Werkstatt oder Produktionsstätte', 'sys')}
                        </WpdfText>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }

    renderLegende(isPdf?: boolean): JSX.Element {
        const styles: any = this.getStyle(isPdf);
        const width: React.CSSProperties = { width: isPdf ? 8 : 11 };

        return (
            <WpdfView
                style={{ ...styles.tabelle, ...styles.tabelle1/*, marginTop: isPdf ? 0 : 0, marginBottom: isPdf ? 15 : 0*/, marginTop: isPdf ? 15 : 0 }}
                pdf={isPdf}
            >
                <WpdfView style={{ display: 'flex', flexDirection: 'row', marginTop: 2 }} pdf={isPdf}>
                    <WpdfView style={{ backgroundColor: this.colorDatenauswertung, ...width }} pdf={isPdf} />{/*#00aa44*/}
                    <WpdfView style={{ marginLeft: 5 }} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>
                            {i18n('Energie wird effizient eingesetzt, kein akuter Handlungsbedarf, Optimierung sicher möglich', 'sys')}
                        </WpdfText>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={{ display: 'flex', flexDirection: 'row', marginTop: 2 }} pdf={isPdf}>
                    <WpdfView style={{ backgroundColor: '#e9e925', ...width }} pdf={isPdf} />
                    <WpdfView style={{ marginLeft: 5 }} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>
                            {i18n('Energieeinsparpotentiale sind mit großer Wahrscheinlichkeit vorhanden', 'sys')}
                        </WpdfText>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={{ display: 'flex', flexDirection: 'row', marginTop: 2 }} pdf={isPdf}>
                    <WpdfView style={{ backgroundColor: '#e6af24', ...width }} pdf={isPdf} />
                    <WpdfView style={{ marginLeft: 5 }} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>{i18n('Energieeinsparpotentiale vorhanden, Energieverbrauch lokalisieren', 'sys')}</WpdfText>
                    </WpdfView>
                </WpdfView>
                <WpdfView style={{ display: 'flex', flexDirection: 'row', marginTop: 2 }} pdf={isPdf}>
                    <WpdfView style={{ backgroundColor: '#dc001f', ...width }} pdf={isPdf} />
                    <WpdfView style={{ marginLeft: 5 }} pdf={isPdf}>
                        <WpdfText pdf={isPdf}>{i18n('erhebliche Energieeinsparpotentiale vorhanden, Maßnahmen planen', 'sys')}</WpdfText>
                    </WpdfView>
                </WpdfView>
            </WpdfView>
        );
    }

    renderLegendeWrapper(column: number): JSX.Element {
        const isFirstColumn: boolean = +column === 1;
        const display: React.CSSProperties = this.state.isSmall && !isFirstColumn && !this.co2Fussabdruck ? { display: 'none' } : {};
        // const borderTop: React.CSSProperties = this.state.isSmall && !this.co2Fussabdruck
        //     ? {} : { borderTop: '1px solid var(--color-bg-headline, #e9e9e9)' };
        const borderTop: React.CSSProperties = this.state.isSmall && this.co2Fussabdruck
            ? { borderTop: '1px solid var(--color-bg-headline, #e9e9e9)' } : {};

        const borderRight: React.CSSProperties = {
            borderRight: `1px solid ${this.state.isSmall || (!this.state.isSmall && !isFirstColumn)
                ? this.backgroundColorSectionTable || '#e9e9e9' : 'white'
            }`
        };
        const borderBottom: React.CSSProperties = { borderBottom: `1px solid ${this.backgroundColorSectionTable || '#e9e9e9'}` };
        const borderLeft: React.CSSProperties = { borderLeft: `1px solid ${isFirstColumn || this.state.isSmall
                ? this.backgroundColorSectionTable || '#e9e9e9' : 'white'
            }`
        };

        return (
            <div
                style={{
                    backgroundColor: this.backgroundColorSectionTable || 'transparent', maxWidth: 640/*648*/, minWidth: 640/*648*/,
                    paddingBottom: 5, ...borderTop, boxSizing: 'border-box', display: 'flex', flex: 1, flexDirection: 'column',
                    marginRight: isFirstColumn && !this.state.isSmall ? -1 : 0,
                    ...display, ...(isFirstColumn && !this.co2Fussabdruck && { marginRight: 20 }), 
                }}
            >
                {isFirstColumn && this.renderInfo()}
                {!isFirstColumn && <>&nbsp;</>}{/*this.renderLegende()*/}
            </div>
        );
    }

    renderMessages(index: number, isPdf?: boolean): JSX.Element[] {
        const styles: any = this.getStyle(isPdf);
        const message: string = index === 1 ? this.state.message1_1 : (index === 2 ? this.state.message2_1 : null);
        const message2: string = index === 1 ? this.state.message1_2 : (index === 2 ? this.state.message2_2 : null);
        const elements: JSX.Element[] = [
            <WpdfView
                key='message-1'
                style={{
                    ...styles.message,
                    color: ((index === 1 && this.state.showBar1) || (index === 2 && this.state.showBar2)) ? '#bbb' : '#a00'
                }}
                pdf={isPdf}
            >
                <WpdfText style={{ margin: 'auto', marginTop: 0, marginBottom: 0 }} pdf={isPdf}>{message || '\xa0'}</WpdfText>
            </WpdfView>,
            <WpdfView
                key='message-2'
                style={{ ...styles.message, color: '#a00' }}
                pdf={isPdf}
            >
                <WpdfText style={{ margin: 'auto', marginTop: 0, marginBottom: 0 }} pdf={isPdf}>{message2 || '\xa0'}</WpdfText>
            </WpdfView>
        ];

        return [
            message && message !== '' ? elements[0] : (message2 && message2 !== '' ? elements[1] : elements[0]),
            message && message !== '' ? elements[1] : (message2 && message2 !== '' ? elements[0] : elements[1])
        ];
    }

    renderTitel(column: number): JSX.Element {
        const { data, jahr, standort } = this.props;
        const bs: string = getBetrieblicheSituationName(data) || null;
        const isFirstColumn: boolean = +column === 1;
        return (
            <>
                {isFirstColumn &&
                    <>
                        <div style={{ fontWeight: 600, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <span style={{ marginRight: 5 }}>{i18n('Betriebsvergleich', 'sys')}</span>{this.renderHelpIcon()}
                        </div>
                        {this.apiService.isAdmin() &&
                            <div style={{ fontSize: 11, color: '#888', display: 'flex', alignItems: 'center' }}>
                                <input
                                    type='checkbox'
                                    checked={this.state.showAll}
                                    onChange={(event: any) => this.setState(
                                        { showAll: event.target.checked },
                                        () => this.contextService.set('benchmarkShowAll', this.state.showAll)
                                    )}
                                />
                                {i18n('Alle Kennzahlen', 'sys')}
                            </div>
                        }
                        {false && bs &&
                            <div style={{ fontSize: 11, color: '#aaa', marginBottom: 5 }}>
                                <input
                                    type='checkbox'
                                    checked={this.state.showCluster}
                                    onChange={(event: any) => this.setState(
                                        { showCluster: event.target.checked },
                                        () => {
                                            this.contextService.set('benchmarkShowCluster', this.state.showCluster);
                                            this.triggerService.fire('reload', IDs.ENT_UNTERNEHMENSDATEN);
                                        }
                                    )}
                                />
                                {i18n('Vergleich mit Cluster', 'sys')} '{bs}' ({i18n('an Stelle des Gewerkes', 'sys')})
                            </div>
                        }
                        <div className={formStyle.formCompact}>
                            <KennzahlenAuswahl
                                jahr={jahr}
                                label={!this.co2Fussabdruck ? '1:' : null}
                                data={data}
                                kennzahlSelected={this.state.kennzahlSelected1}
                                onKennzahlChange={(kennzahlSelected: string) => this.selectKennzahl(1, kennzahlSelected, jahr, standort)}
                                // fontSize={11}
                                width={205}
                                padding={0}
                                showAll={this.state.showAll}
                            />
                        </div>
                    </>
                }
                {!isFirstColumn &&
                    <div className={formStyle.formCompact}>
                        <KennzahlenAuswahl
                            jahr={jahr}
                            label='2:'
                            data={data}
                            kennzahlSelected={this.state.kennzahlSelected2}
                            onKennzahlChange={(kennzahlSelected: string) => this.selectKennzahl(2, kennzahlSelected, jahr, standort)}
                            // fontSize={11}
                            width={205}
                            padding={0}
                            showAll={this.state.showAll}
                        />
                    </div>
                }
            </>
        );
    }

    renderTitelWrapper(column: number): JSX.Element {
        const isFirstColumn: boolean = +column === 1;
        const borderRadius = !isFirstColumn && !this.co2Fussabdruck && this.state.isSmall
            ? {} : { borderTopRightRadius: 'var(--border-radius-headline)', borderTopLeftRadius: 'var(--border-radius-headline)' };
        return (
            <div
                style={{
                    maxWidth: 640/*648*/, minWidth: 640/*648*/, ...borderRadius, display: 'flex', flex: 1, flexDirection: 'column',
                    ...(isFirstColumn && !this.co2Fussabdruck && { marginRight: 20 })
                }}
            >
                <div
                    style={{
                        fontSize: 'var(--font-size-headline)', backgroundColor: 'var(--color-bg-headline)',
                        maxHeight: 'var(--height-headline)', minHeight: 'var(--height-headline)', padding: '0 10px 0 20px',
                        ...borderRadius/*: '10px 10px 0 0'*/, display: 'flex', flex: 1, flexDirection: 'row',
                        justifyContent: isFirstColumn ? 'space-between' : 'flex-end', alignItems: 'center'
                    }}
                >
                    {this.renderTitel(column)}
                </div>
            </div>
        );
    }

    selectKennzahl(kz: number, kennzahlSelected: string, jahr: number, standort: number): void | JSX.Element {
        this.contextService.set(`benchmarkingKennzahl${kz}`, kennzahlSelected);
        const info_gewerk = this.props.data['info_gewerk'] || {};
        // console.log(kennzahlSelected);
        // Die Kennzahlen aus dieser E-Tool-Anwendung
        const kennzahlen_eigene = standort
            ? (this.props.data[IDs.KENNZIFFERN_BERECHNET_STANDORT] || {})[standort] || {}
            : this.props.data[IDs.KENNZIFFERN_BERECHNET] || {};
        // console.log('KENN EIGENE: ', kennzahlen_eigene);
        // Die aggregierten Kennzahlen aus der zentralen Datenbank
        const kennzahlen_aggregiert = (this.props.data[IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION] || [])
            .filter((item: any) => (item.modus || 100) === 100);
        // Die Kennzahlen-Definition aus der zentralen Datenbank
        const kennzahlen_definition = this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION] || [];
        // Einheit holen (die Kennzahl muss es geben, da wir sie sonst nicht hätten wählen können)
        if (!kennzahlen_definition) {
            return <div>Fehler keine Kennzahlen-Definition</div>;
        }
        const kz_found = kennzahlen_definition.find((kennz: any) => kennz.kuerzel === kennzahlSelected);
        const einheit = kz_found && kz_found.einheit;

        const item = kennzahlen_aggregiert.find((ka: any) => {
            // console.log(ka.jahr, jahr, ka.kuerzel, kennzahlSelected);
            // return ka.jahr === jahr && ka.kuerzel === kennzahlSelected;
            return ka.jahr === 0 && ka.kuerzel === kennzahlSelected && !ka.cluster_name && !ka.cluster_id; // Wir nehmen Jahr = 0 für "ALLE"
        });
        const value = kennzahlen_eigene[jahr] ? kennzahlen_eigene[jahr][kennzahlSelected] /*|| 0*/ : 0;
        const stateToSet: any = { jahr };
        let msg_gewerk = `${i18n(info_gewerk.gewerk_use_cluster ? 'Cluster' : 'Gewerk', 'sys')}: `;

        if (info_gewerk.gewerk_use_cluster) {
            msg_gewerk += getStaticOption(IDs.ENT_UNTERNEHMENSDATEN, 'betriebliche_situation', info_gewerk.betriebliche_situation);
        } else {
            msg_gewerk += getGewerkName(this.props.data);
        }
        stateToSet[`kennzahlSelected${kz}`] = kennzahlSelected;
        stateToSet[`einheit${kz}`] = einheit;
        // console.log('benchmark item found', jahr, kennzahlSelected, item);
        if (item && item.anzahl > 9) {
            // let start = item.wert_min === item.wert_min ? item.wert_min - 10 : item.wert_min;
            let start = item.wert_min;
            if (value && value !== 0 && value < start) {
                start = value;
            }
            // let end = item.wert_max === item.wert_avg ? item.wert_max + 10 : item.wert_max;
            let end = item.wert_max;
            if (value && value > end) {
                end = value;
            }
            stateToSet[`anzahl${kz}`] = item.anzahl;
            stateToSet[`start${kz}`] = start;
            stateToSet[`end${kz}`] = end;
            stateToSet[`average${kz}`] = item.wert_avg;
            stateToSet[`value${kz}`] = value;
            stateToSet[`message${kz}_1`] = `[${item.anzahl} ${i18n('Referenzdatensätze', 'sys')} / ${msg_gewerk}]`;
            stateToSet[`message${kz}_2`] = '';
            stateToSet[`showBar${kz}`] = true;
        } else {
            if(item && item.anzahl && item.anzahl < 10) {
                stateToSet[`anzahl${kz}`] = item.anzahl;
                stateToSet[`message${kz}_1`] = `[${i18n('Zu wenig Referenzwerte gefunden!', 'sys')}]`;
            } else {
                stateToSet[`message${kz}_1`] = `[${i18n('Keine Referenzwerte gefunden!', 'sys')}]`;
            }

            if (value) {
                stateToSet[`message${kz}_2`] = ''; // `Eigener Wert: ${formatNumber(value, 2)} ${einheit}`;
            } else {
                stateToSet[`message${kz}_2`] = ''; // 'Kein eigener Wert vorhanden!';
            }
            stateToSet[`showBar${kz}`] = false;
        }
        this.setState(stateToSet);
    }
    setAgain(isTrigger: boolean = true): void {
        this.selectKennzahl(1, this.state.kennzahlSelected1, this.props.jahr, this.props.standort);
        this.selectKennzahl(2, this.state.kennzahlSelected2, this.props.jahr, this.props.standort);

        if (isTrigger) {
            this.processPdfData(true);
        }
    }

    setColors(): void {
        this.colorDatenauswertung = (SectionStyle.getSectionColors() || {}).datenauswertung;
        this.backgroundColorSectionTable = new SectionStyle().getPropertyValue('--color-section-table-background');
    }
}
